module.exports = __webpack_public_path__ + "img/code.1423c2dc.png";